import styled from 'styled-components';

const StyledContainer = styled.div`
    font-size: 13px;
    color: ${props => props.color};
`;

export { StyledContainer };
